import {TabulatorFull as Tabulator} from 'tabulator-tables';

const fbcLookupForm = document.getElementById('fbc-lookup-form');
let table = null;
fbcLookupForm.addEventListener('submit', function(event) {
    event.preventDefault();

    const parcelNumber = document.getElementById('parcel-number').value;
    const resultsContainer = document.getElementById('fbc-lookup-results');

    if (WPFR_FBC_LOOKUP_DATA === undefined || !WPFR_FBC_LOOKUP_DATA.ajax_url || !WPFR_FBC_LOOKUP_DATA.nonce) {
        resultsContainer.innerHTML = 'Error: Missing configuration data.';
        return;
    }

    // Destroy existing table if it exists
    if (table) {
        table.destroy();
        table = null;
    }

    resultsContainer.innerHTML = 'Searching...';
    
    fetch(WPFR_FBC_LOOKUP_DATA.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'wpfr_fbc_lookup',
            nonce: WPFR_FBC_LOOKUP_DATA.nonce,
            parcel_number: parcelNumber
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            const rows = data.rows;
            if (rows.length > 0) {
                table = new Tabulator(resultsContainer, {
                    data: rows,
                    autoColumns: true,
                });
            } else {
                resultsContainer.innerHTML = 'No results found.';
            }
        } else {
            resultsContainer.innerHTML = 'Error: ' + data.message;
        }
    })
    .catch(error => {
        resultsContainer.innerHTML = 'Error: ' + error.message;
    });
});